import { useState } from 'react';
import type { ReactNode } from 'react';
import Navbar from '../../pages/home/components/Navbar';
import Footer from '../../pages/home/components/Footer';
import WhatsAppButton from '../../pages/home/components/WhatsAppButton';
import AppointmentModal from '../../pages/home/components/AppointmentModal';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';

interface PageShellProps {
  children: (onOpenModal: () => void) => ReactNode;
}

export default function PageShell({ children }: PageShellProps) {
  const [modalOpen, setModalOpen] = useState(false);
  useScrollAnimation();

  return (
    <div className="min-h-screen bg-white font-sans">
      <Navbar onOpenModal={() => setModalOpen(true)} />
      <main>{children(() => setModalOpen(true))}</main>
      <Footer />
      <WhatsAppButton />
      <AppointmentModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />
    </div>
  );
}
